// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__NcxKd","requiredAsterisk":"Info_requiredAsterisk__2ASoO"};